import { UserSubOrderEnrichedStatusEnum } from '@redteclab/api/clients/bully'

const ParcelLabStatuses = {
  Delivered: 'delivered',
  Shipped: 'shipped',
} as const

export const ApiContractAndParcelLabStatuses = {
  ...UserSubOrderEnrichedStatusEnum,
  ...ParcelLabStatuses,
}

export type OrderStatusConfigLabels =
  (typeof ApiContractAndParcelLabStatuses)[keyof typeof ApiContractAndParcelLabStatuses]

export type OrderStatusProps = {
  color: string
  lastOrderOrderStatus: OrderStatusConfigLabels
  message: string | undefined
}

export type AccountOverviewOrderStatusWithDate = {
  deliveryDate?: string
  isNowOrder?: boolean
  orderStatus: OrderStatusConfigLabels
  shippingStatusLabels: Record<OrderStatusConfigLabels, string>
  timeRange?: string
}
